/* eslint-disable react/button-has-type */
import React, { useState } from 'react'
import Header from '@pages/companies/header'
import {
  ArrowBackContainer,
  ArrowBackTextContainer,
  ActivityContainer,
  Row,
} from './styles'
import ArrowBack from '@components/arrowBack'
import { useNavigate } from 'react-router-dom'
import CustomCalendar from '../../components/calendar/bigCalendar'
import CustomDataPicker from '../../components/calendar/datapicker'
import CreateActivityModal from '@components/modal/createActivityModal'

const AtivitySchedule = () => {
  const navigate = useNavigate()
  const [events, setEvents] = useState([{}])
  const [date, setDate] = useState(new Date())
  const [showModal, setShowModal] = useState(false)
  const [showCreateActivity, setShowCreateActivity] = useState(false)
  return (
    <>
      <Header />
      <ActivityContainer>
        <ArrowBackContainer>
          <ArrowBack onClick={() => { navigate(-1) }} />
          <ArrowBackTextContainer>
            <h1>Vida ativa: Agenda de atividades</h1>
            <p>Clique no quadro para criar uma atividade</p>
          </ArrowBackTextContainer>
        </ArrowBackContainer>
        <Row>
          <CustomDataPicker
            date={date}
            setDate={setDate}
            setShowModal={setShowModal}
            onOpenCreateActivity={() => setShowCreateActivity(true)}
          />
          <CreateActivityModal
            isOpen={showCreateActivity}
            onClose={() => setShowCreateActivity(false)}
          />

          <CustomCalendar
            date={date}
            setDate={setDate}
            events={events}
            setEvents={setEvents}
            showModal={showModal}
            setShowModal={setShowModal}
          />
        </Row>
      </ActivityContainer>
    </>
  )
}

export default AtivitySchedule
